module.exports = __webpack_public_path__ + "media/images/transfer-divider-f8b969a1ebdabaec9572908b7483c187.svg";